<template>
  <h1>Oops... should not be here!</h1>
</template>
<script>
import { isValidRedirectURI } from "./js/helper";

export default {
  name: "Redirect",
  created() {
    var accessToken = this.$route.query.access_token;
    console.log(this.$route.query);
    console.log("hello", accessToken);
    if (accessToken) {
      accessToken = accessToken.split(":")[1].split(".")[0];
      // Check if the redirect is due to an account-linking request:
      var redirectURI = this.$cookie.get("link_account_redirect_uri");
      if (isValidRedirectURI(redirectURI)) {
        console.log("Completing account linking");
        // invalidate the redirect_uri cookie (note there is a possible race condition by using cookies to determine how to handle the oath redirect)
        this.$cookie.delete("link_account_redirect_uri");
        var state = this.$cookie.get("link_account_state");
        window.location.href = `${redirectURI}#access_token=${accessToken}&token_type=bearer&state=${state}`;
      }
      // Otherwise route to the UI home
      else this.$router.push({ name: "Home", params: { accessToken } });
    }
  }
};
</script>


// WEBPACK FOOTER //
// Redirect.vue?15d87042